module.exports = __webpack_public_path__ + "media/images/landing/logo-footer-white-327fbb0075caca90e0471da6cf0a0cd5.png";